<template>
  <v-dialog
    data-testid="deleteSectionDecisionDialog-dialog-deleteSection"
    width="500"
    :value="show"
    @click:outside="$emit('cancel')"
  >
    <v-card data-testid="deleteSectionDecisionDialog-card-deleteSection">
      <v-card-title
        data-testid="deleteSectionDecisionDialog-cardTitle-deleteSection"
        class="h6 font-weight-bold blue-grey--text text--darken-3 mb-0"
      >
        {{ $t('routines.scoring.section_questions_required_warning_title') }}
      </v-card-title>
      <v-card-subtitle
        class="body-1 blue-grey--text text--darken-2 mt-2 mb-0"
        data-testid="deleteSectionDecisionDialog-cardSubtitle-deleteSection"
      >
        {{
          $t('routines.scoring.section_questions_required_warning_description')
        }}
        <template v-if="showsSectionPicker">
          <br />
          <br />
          {{ $t('routines.scoring.delete_section_alternatives') }}
        </template>
      </v-card-subtitle>
      <v-card-text
        v-if="showsSectionPicker"
        class="px-6 pt-4 pb-0"
        data-testid="deleteSectionDecisionDialog-cardText-deleteSection"
      >
        <v-select
          data-testid="deleteSectionDecisionDialog-select-targetSection"
          dense
          hide-details
          item-text="text"
          item-value="value"
          outlined
          :items="availableSections"
          :label="$t('routines.scoring.move_questions_to_section_label')"
          :value="selectedSectionId"
          @input="handleSectionChange"
        />
      </v-card-text>
      <v-card-actions
        class="px-6 pb-5 pt-4 d-flex flex-column justify-space-between align-end"
        data-testid="deleteSectionDecisionDialog-cardActions-deleteSection"
      >
        <Button
          v-if="showsSectionPicker"
          plain
          color="primary"
          class="mb-2"
          data-testid="deleteSectionDecisionDialog-button-moveSectionQuestions"
          :disabled="isMoveActionDisabled"
          :text="$t('routines.scoring.move_questions_and_delete_section')"
          @click="handleMoveQuestions"
        />
        <Button
          plain
          color="danger"
          data-testid="deleteSectionDecisionDialog-button-deleteSectionAndQuestions"
          :text="$t('routines.scoring.delete_section_and_its_contents')"
          @click="$emit('deleteSectionAndQuestions')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'

import Button from '@/components/UI/Button'

export default {
  name: 'DeleteSectionDecisionDialog',

  components: {
    Button,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    availableSections: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedSectionId: null,
    }
  },

  computed: {
    showsSectionPicker() {
      return !_.isEmpty(this.availableSections)
    },

    isMoveActionDisabled() {
      return !this.selectedSectionId
    },
  },

  watch: {
    show(value) {
      if (!value) {
        this.selectedSectionId = null
      }
    },
  },

  methods: {
    handleSectionChange(value) {
      this.selectedSectionId = value
    },

    handleMoveQuestions() {
      if (!this.selectedSectionId) {
        return
      }

      this.$emit('moveSectionQuestions', this.selectedSectionId)
    },
  },
}
</script>
